// extracted by mini-css-extract-plugin
export default {"wrapper":"Stage_wrapper_Ji2sq","title":"Stage_title_n1h7K","stageNumber":"Stage_stageNumber_livwi","description":"Stage_description_Z7qna"};